import React, { FunctionComponent, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { AppRoute } from "@app/models/AppRoute";
import { useAppDispatch, useAppSelector, useProfileMenuPermissions } from "@app/hooks";
import { openAccessDeniedDialog } from "@app/store/accessDeniedDucks";
import AppLoadingIndicator from "@app/components/AppLoadingIndicator";

/** Route guard for /my-profile. Redirects unauthorized users and shows the Access Denied dialog. */
const ProfileRouteGuard: FunctionComponent = ({ children }) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { permissionsLoaded, showMyProfile } = useProfileMenuPermissions();
  const isDialogAlreadyOpen = useAppSelector((state) => state.accessDenied.open);

  useEffect(() => {
    if (!permissionsLoaded || showMyProfile || isDialogAlreadyOpen) return;

    dispatch(openAccessDeniedDialog());

    // PUSH = navigated from within LPC → go back to the previous page
    // POP / REPLACE = direct URL or external link → redirect to Home
    if (history.action === "PUSH") {
      history.goBack();
    } else {
      history.replace(AppRoute.Home);
    }
  }, [permissionsLoaded, showMyProfile, isDialogAlreadyOpen, dispatch, history]);

  if (!permissionsLoaded) {
    return <AppLoadingIndicator />;
  }

  if (showMyProfile) {
    return <>{children}</>;
  }

  return null;
};

export default ProfileRouteGuard;
